module.exports = __webpack_public_path__ + "img/10-en.e45b6707.png";